var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.learningArea)?_c('div',{staticClass:"learning-area-label"},[(_vm.showIcon)?_c(_vm.badgeIcon,{tag:"component",class:[
      'learning-area-label__icon',
      _vm.extraSmallMobile && 'learning-area-label__icon--mobile' ]}):_vm._e(),(_vm.dotIcon)?_c('div',{class:[
      'learning-area-label__dot-icon',
      ("learning-area-label__dot-icon--" + (_vm.badgeIcon.toLowerCase())) ]}):_vm._e(),(_vm.showText)?_c('div',{class:[
      'learning-area-label__text',
      _vm.uppercase && 'learning-area-label__text--uppercase',
      _vm.extraSmallMobile && 'learning-area-label__text--extra-small' ]},[_vm._v("\n    "+_vm._s(_vm.learningArea)+"\n  ")]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }